export default function SingleGamesPanel() {
    return <>Single</>
}